import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { useRef } from "react";
import { createVarsResolver } from "./auth-service-tools191.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { useFloatingIndicator } from "./auth-service-tools311.js";
import classes from "./auth-service-tools312.js";
import { useMergedRef } from "./auth-service-tools278.js";
const defaultProps = {};
const varsResolver = createVarsResolver((_theme, _ref) => {
  let {
    transitionDuration
  } = _ref;
  return {
    root: {
      "--transition-duration": typeof transitionDuration === "number" ? `${transitionDuration}ms` : transitionDuration
    }
  };
});
const FloatingIndicator = factory((_props, ref) => {
  const props = useProps("FloatingIndicator", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    target,
    parent,
    transitionDuration,
    mod,
    displayAfterTransitionEnd,
    ...others
  } = props;
  const getStyles = useStyles({
    name: "FloatingIndicator",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  const innerRef = useRef(null);
  const {
    initialized,
    hidden
  } = useFloatingIndicator({
    target,
    parent,
    ref: innerRef,
    displayAfterTransitionEnd
  });
  const mergedRef = useMergedRef(ref, innerRef);

  if (!target || !parent) {
    return null;
  }

  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
    ref: mergedRef,
    mod: [{
      initialized,
      hidden
    }, mod],
    ...getStyles("root"),
    ...others
  });
});
FloatingIndicator.displayName = "@mantine/core/FloatingIndicator";
FloatingIndicator.classes = classes;
export { FloatingIndicator };